import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import { routes } from '.'
import { RouteRenderer } from './renderer'

export const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {routes.map(({ nested, component, ...route }, index) => (
          <Route
            key={index}
            {...route}
            render={(props) => (
              <RouteRenderer {...props} nested={nested} component={component} />
            )}
          />
        ))}
      </Switch>
    </BrowserRouter>
  )
}
